import { useIsFocused } from "expo-router/react-navigation";
import { router } from 'expo-router';
import { useLayoutEffect } from 'react';

import { useNpoOnboarding } from '@/api/hooks/meHooks';
import { useUpdateNonProfitOrg } from '@/api/hooks/nonProfitOrgHooks';
import { NonProfitOrg } from '@/api/models/nonProfitOrgModels';
import NpoTotalSalariesForm from '@/components/forms/NpoTotalSalariesForm';
import { useAuth } from '@/contexts/authContext';
import { useNpoLoginScreenState } from '@/contexts/npoLoginScreenStateContext';
import { TotalSalariesData } from '@/lib/validations/NpoOnboardingSchema';
import { safeJsonParse } from '@/utils/jsonParse';

const TotalSalaries = () => {
  const { state: authState } = useAuth();
  const { state: npoScreensState, setCurrentPage } = useNpoLoginScreenState();
  const { mutateAsync: onBoardingUpdate, isPending: onBoardingIsPending } = useNpoOnboarding(
    authState.signUpData?.loginEmail?.type ?? 'CHURCH'
  );
  const { mutateAsync: nonProfitUpdate, isPending: nonProfitIsPending } = useUpdateNonProfitOrg();

  const isFocused = useIsFocused();
  useLayoutEffect(() => {
    if (isFocused) setCurrentPage(6);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused]);

  const nonProfitOrg = safeJsonParse<NonProfitOrg>(npoScreensState.initialNpoData ?? '');

  const onSubmit = async (data: TotalSalariesData) => {
    try {
      nonProfitUpdate(
        {
          npoId: authState.signUpData?.loginEmail?.npoId ?? '',
          totalSalaries: data.totalSalaries,
          totalEmployeeBeneficits: data.otherEmployeesBenefits
        },
        {
          onSuccess: () => {
            onBoardingUpdate(
              {
                preferenceId: authState.preferenceId ?? '',
                totalSalaries: true
              },
              {
                onSuccess: () => {
                  router.navigate('/(app)/login/nonProfit/onBoarding/pL');
                }
              }
            );
          },
          onError: (e) => {
            console.error(e);
          }
        }
      );
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <NpoTotalSalariesForm
      nonProfitOrg={nonProfitOrg}
      isLoading={onBoardingIsPending || nonProfitIsPending}
      onSubmitTapped={onSubmit}
    />
  );
};

export default TotalSalaries;
